export default {
  QQ_CLIENT_ID: "243455",
  QQ_REDIRECT_URL: "http://www.codescholar.cn/callback/qq",
  GITEE_CLIENT_ID: "d029020a6839273e0e82d853783874bf1f4f34b95da6ebcbc230e6603ff9b656",
  GITEE_REDIRECT_URL: "http://www.codescholar.cn/callback/gitee",
  WEIBO_CLIENT_ID: "2285022919",
  WEIBO_REDIRECT_URL: "http://www.codescholar.cn/callback/weibo",
};
